__turbopack_context__.v({
  "breadcrumb": "Breadcrumbs-module__GhxyDa__breadcrumb",
  "breadcrumbs": "Breadcrumbs-module__GhxyDa__breadcrumbs",
  "breadcrumbsContainer": "Breadcrumbs-module__GhxyDa__breadcrumbsContainer",
  "link": "Breadcrumbs-module__GhxyDa__link",
});
